function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var makeButtonStyles = function makeButtonStyles(_ref) {
  var primitives = _ref.primitives,
    tokens = _ref.tokens;
  var getButtonStyles = function getButtonStyles(_ref2) {
    var size = _ref2.size,
      variant = _ref2.variant;
    var button = tokens.button;

    // Rewrite font size value to incorporate root font size factor
    var fontSize = size === "dense" ? primitives.fontSizes[2] : primitives.fontSizes[3];
    return _objectSpread(_objectSpread({}, button[variant][size].default), {}, {
      alignItems: "flex-start",
      fontSize: fontSize,
      "&:hover": _objectSpread(_objectSpread({}, button[variant][size].hover), {}, {
        fontSize: fontSize
      }),
      "&.Mui-disabled": _objectSpread(_objectSpread({}, button[variant][size].disabled), {}, {
        fontSize: fontSize
      }),
      "&:focus-visible": _objectSpread(_objectSpread({}, button[variant][size].focus), {}, {
        fontSize: fontSize
      }),
      "&:focus:active": _objectSpread(_objectSpread({}, button[variant][size].pressed), {}, {
        fontSize: fontSize
      }),
      "&:active": _objectSpread(_objectSpread({}, button[variant][size].pressed), {}, {
        fontSize: fontSize
      })
    });
  };
  var linkPseudoStateOverrides = {
    textUnderlineOffset: "0.375em",
    transition: "text-decoration-color ".concat(primitives.transitions.duration["1"], " ").concat(primitives.transitions.easing.smooth)
  };
  var linkDenseOverrides = {
    paddingTop: primitives.spacings["1"],
    paddingBottom: primitives.spacings["1"],
    paddingLeft: primitives.spacings["0"],
    paddingRight: primitives.spacings["0"],
    fontSize: primitives.fontSizes[2]
  };
  return {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true
      }
    },
    MuiButton: {
      defaultProps: {
        variant: "contained"
      },
      styleOverrides: {
        outlined: _objectSpread(_objectSpread({}, getButtonStyles({
          size: "defaultSize",
          variant: "outlined"
        })), {}, {
          "&[aria-expanded='true']": {
            backgroundColor: tokens.colors["activated-fill-subtle"]
          }
        }),
        outlinedSizeSmall: getButtonStyles({
          size: "dense",
          variant: "outlined"
        }),
        contained: _objectSpread(_objectSpread({}, getButtonStyles({
          size: "defaultSize",
          variant: "contained"
        })), {}, {
          "&[aria-expanded='true']": {
            backgroundImage: "linear-gradient( ".concat(tokens.colors["activated-fill-subtle-on-fill-primary"], ", ").concat(tokens.colors["activated-fill-subtle-on-fill-primary"], "), linear-gradient( ").concat(tokens.colors["fill-primary"], ", ").concat(tokens.colors["fill-primary"], ")")
          }
        }),
        containedSizeSmall: getButtonStyles({
          size: "dense",
          variant: "contained"
        }),
        text: _objectSpread(_objectSpread({}, getButtonStyles({
          size: "defaultSize",
          variant: "text"
        })), {}, {
          "&[aria-expanded='true']": {
            backgroundColor: tokens.colors["activated-fill-subtle"]
          }
        }),
        textSizeSmall: getButtonStyles({
          size: "dense",
          variant: "text"
        }),
        startIcon: {
          "& svg": {
            color: "inherit"
          }
        },
        endIcon: {
          "& svg": {
            color: "inherit"
          }
        },
        iconSizeMedium: {
          "& > *:first-of-type": {
            fontSize: "inherit"
          }
        },
        root: {
          '& [class*="MuiTouchRipple-root"]': {
            display: "none"
          },
          "&:has([class*='MuiButton-endIcon'])": {
            textAlign: "right"
          },
          "&:has([class*='MuiButton-startIcon'])": {
            textAlign: "left"
          },
          "&[class*='MuiButton-link-button']": _objectSpread(_objectSpread({}, getButtonStyles({
            size: "defaultSize",
            variant: "link-button"
          })), {}, {
            "&:hover": _objectSpread(_objectSpread({
              boxShadow: "none"
            }, tokens.textLink.hoverState), linkPseudoStateOverrides),
            "&:active, &:focus:active": _objectSpread(_objectSpread({
              boxShadow: "none"
            }, tokens.textLink.pressedState), linkPseudoStateOverrides),
            "& [class*='MuiButton-startIcon']": {
              marginRight: primitives.spacings["1"],
              marginLeft: 0
            }
          }),
          "&[class*='MuiButton-link-buttonSizeSmall']": _objectSpread(_objectSpread({}, getButtonStyles({
            size: "dense",
            variant: "link-button"
          })), {}, {
            lineHeight: primitives.lineHeights.default,
            "&:hover": _objectSpread(_objectSpread(_objectSpread({
              boxShadow: "none"
            }, tokens.textLink.hoverState), linkPseudoStateOverrides), linkDenseOverrides),
            "&:active, &:focus:active": _objectSpread(_objectSpread(_objectSpread({
              boxShadow: "none"
            }, tokens.textLink.pressedState), linkPseudoStateOverrides), linkDenseOverrides),
            "&:focus-visible": _objectSpread(_objectSpread({}, linkDenseOverrides), {}, {
              lineHeight: primitives.lineHeights.default,
              "&:hover": {
                outline: "".concat(primitives.borderWidths.large, " solid ").concat(tokens.colors["ink-focus"]),
                outlineOffset: "1px"
              }
            })
          }, linkDenseOverrides),
          "&[aria-expanded='true'] [class*='MuiButton-endIcon'] svg": {
            transform: "rotate(180deg)"
          }
        }
      }
    },
    MuiLoadingButton: {
      defaultProps: {
        loadingPosition: "start",
        variant: "contained"
      },
      styleOverrides: {
        root: {
          textAlign: "left",
          "&[class*='MuiLoadingButton-loading']": {
            opacity: "0.6"
          },
          "&[class*='MuiButton-link-button'].Mui-disabled": {
            padding: "".concat(primitives.spacings["1"], " 0px ").concat(primitives.spacings["1"], " ").concat(primitives.spacings["1"]),
            opacity: "0.6"
          },
          "&:has([class*='MuiLoadingButton-loadingIndicatorEnd'])": {
            textAlign: "right"
          },
          '& [class*="MuiLoadingButton-loadingIndicator"]': {
            '& [class*="DhigCircularProgress--foreground"]': {
              color: "inherit"
            }
          }
        },
        loadingIndicator: {
          position: "static",
          marginTop: "3px",
          "& svg": {
            color: "inherit"
          }
        },
        loadingIndicatorStart: {
          marginRight: primitives.spacings["2"],
          marginLeft: "-".concat(primitives.spacings["1"])
        },
        loadingIndicatorEnd: {
          marginRight: "-".concat(primitives.spacings["1"]),
          marginLeft: primitives.spacings["2"]
        }
      }
    }
  };
};